module.exports = __webpack_public_path__ + "5b832b5103f5025cf2bc769a36835196.svg";